import { render, staticRenderFns } from "./GiftAidIcon.vue?vue&type=template&id=cbe9c96a&"
import script from "./GiftAidIcon.vue?vue&type=script&lang=ts&"
export * from "./GiftAidIcon.vue?vue&type=script&lang=ts&"
import style0 from "./GiftAidIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports